<template>
    <div>
        <div class="menu-top">
            <ul class="menu-ul-top-level">
                <li class="menu-li-top-level" :class="selectedItem == 0 ? 'activeLink' : ''" @click="setSelectedItem(0)">Přehled</li>
                <li v-if="!isProjektant" class="menu-li-top-level" :class="selectedItem == 1 ? 'activeLink' : ''" @click="setSelectedItem(1)">Podání</li>
                <li class="menu-li-top-level" :class="selectedItem == 10 ? 'activeLink' : ''" @click="setSelectedItem(10)">Stanoviska</li>
                <li v-if="!isInvestor && !isProjektant && !isManager" class="menu-li-top-level" :class="selectedItem == 2 ? 'activeLink' : ''" @click="setSelectedItem(2)">Nové podání</li>
            </ul>
        </div>

        <div v-if="isEditor || isAdmin" class="menu-middle">
            <ul class="menu-ul-top-level">
                <li class="menu-li-top-level" :class="selectedItem == 3 ? 'activeLink' : ''" @click="setSelectedItem(3)">Uživatelé</li>
                <li>
                    Číselníky
                    <ul>
                        <li :class="selectedItem == 4 ? 'activeLink' : ''" @click="setSelectedItem(4)">Typ DOSS</li>
                        <li :class="selectedItem == 5 ? 'activeLink' : ''" @click="setSelectedItem(5)">DOSS</li>
                        <li :class="selectedItem == 6 ? 'activeLink' : ''" @click="setSelectedItem(6)">DOSS pracoviště</li>
                        <li :class="selectedItem == 7 ? 'activeLink' : ''" @click="setSelectedItem(7)">Druh podání</li>
                        <li :class="selectedItem == 8 ? 'activeLink' : ''" @click="setSelectedItem(8)">Druh stanoviska</li>
                        <li :class="selectedItem == 9 ? 'activeLink' : ''" @click="setSelectedItem(9)">Stav</li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="menu-bottom">
            <button @click="loggoutUser">Odhlásit</button>
        </div>
    </div>
</template>

<script>
    import { PublicClientApplication } from '@azure/msal-browser';   

    export default {
        name: 'Menu-Component',
        props: ['isEditor', 'isAdmin', 'isManager', 'isInvestor', 'isProjektant', 'menuItem'],
        data() {
            return {
                selectedItem: -1
            }
        },
        watch: {
            menuItem(newVal, oldVal) {
                if (oldVal !== newVal) {
                    this.selectedItem = this.menuItem
                }
            }
        },
        methods: {
            async loggoutUser() {
                const msalConfig = {
                    auth: {
                        clientId: process.env.VUE_APP_MSAL_CLIENTID,
                        authority: process.env.VUE_APP_MSAL_AUTHORITY
                    }
                }

                const msalInstance = new PublicClientApplication(msalConfig);

                await msalInstance.logoutPopup();

                localStorage.clear();

                this.$emit('loggoutUser')
            },
            setSelectedItem(value) {
                this.selectedItem = value
                this.$emit('setMenuItem', value)
            }
        }
    }
</script>